import React from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { Link } from "react-router";

const DashboardBackBtn = (props) => {
  return (
    <Link to={props.to}>
      <div
        className={`group absolute xs:top-6 sm:top-6 lg:top-10 sm:left-5 lg:left-4 flex cursor-pointer justify-center items-center xs:px-2 sm:px-3 lg:px-5 xs:py-[2px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
      >
        <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
        <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
          Back
        </p>
      </div>
    </Link>
  );
};
export default DashboardBackBtn;
